{
  "longPressMessage": "Натисніть і утримуйте, щоб відкрити попередній перегляд"
}
